import { useCallback } from "react";

import { frameStencilController, getPlayerBallStencil, getStencilById } from "../../utils";
import { UpdateFrameStencils } from "./use-update-frame-stencils";

export interface RemoveStencilProps {
  id: string;
}
export type RemoveStencilFunc = (props: RemoveStencilProps) => void;

export const useRemoveStencil = (updateFrameStencils: UpdateFrameStencils): RemoveStencilFunc => {
  return useCallback(
    ({ id }: RemoveStencilProps) => {
      // frame stencils set state
      updateFrameStencils((prevState) => {
        if (!prevState) return prevState;
        // find stencil by its id
        const { stencil } = getStencilById({ stencils: prevState || [], id });
        if (!stencil) return prevState;

        const ballStencil = getPlayerBallStencil({ stencil, frameStencils: prevState });

        return [stencil, ...(ballStencil ? [ballStencil] : [])].reduce(
          (acc, stencil) => frameStencilController({ operation: "REMOVE", stencils: acc, stencil }),
          prevState
        );
      });
    },
    [updateFrameStencils]
  );
};
